<template>
    <div class="list">
        <div class="list-wrapper"
            v-if="isLoaded && isHaveItem">
            <purchase-item
                v-for="(purchase, k) in purchases"
                :key="k"
                :index="k"
                :lbl="lbl"
                :purchase="purchase"
                :categoryName="getCategoryName(purchase.categoryID)"
                @clickPurchase="clickPurchase($event)"
            ></purchase-item>
        </div>
        <div v-if="isLoaded && !isHaveItem">
            <div class="empty-text">{{lbl.history.empty}}</div>
        </div>
        <serial-modal
            :lbl="lbl"
            :busSerialModal="busSerialModal"
            @serialExpired="serialExpired($event)">
        </serial-modal>
        <modal view="purchase-list"
            :busModal="busModal"></modal>
    </div>
</template>
<script>
import Vue from 'vue';
import moment from "moment";
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/locale.js';
//service
import PurchaseItem from '@/components/history/PurchaseItem.vue';
import BzbsHistory from '@/service/BzbsHistory.js';
import { CategoryConfigBuilder } from "@/service/config/CategoryConfigModel.js";
import BzbsCampaign from "@/service/BzbsCampaign.js";
//modal
import Modal from '@/components/modal/Modal.vue';
import SerialModal from '@/components/modal/SerialModal.vue';
/**
 * property
 * @property {object} lbl Text for component.
 * @property {boolean} isLoading Loading status.
 * @property {object} listConfig Configuration for call api.
 * @property {object} filterConfig Filter configuration for call api.
 * @property {object} busEvent Bus event for parent component.
 * event
 * @event clickPurchase Click purchase item.
 * parent component bus event.
 * @event toggleLoading toggle loading in parent component.
 */
export default {
    name: "PurchaseList",
    components: {
        PurchaseItem,
        Modal,
        SerialModal
    },
    props: {
        lbl: Object,
        isLoading: Boolean,
        listConfig: Object,
        filterConfig: Object,
        busEvent: Object,
        busModal: Object
    },
    data: function () {
        return {
            purchases: [],
            isLoaded: false,
            isHaveItem: true,
            isForceRender: true,
            isSerialLoading: false,
            cateList: [],

            clickedIndex: 0,
            isLoadedMore: false,

            campaignType: Vue.CampaignType,
            busSerialModal: new Vue()
        };
    },
    created: function () {
        this.initialCategory();
        this.getList();
    },
    mounted: function () {
        //page busEvent.
        this.busEvent.$on('switchLang', this.switchLang);
        this.busEvent.$on('reinitList', this.setConfig);
        //modal busEvent
        window.scrollTo(0, 0);
        this.$nextTick(() => {
            this.initialSeeMore();
        });
    },
    beforeDestroy: function () {
        this.removeScrollEvent();
    },
    methods: {
        //initial
        initialCategory: function() {
            this.cateList = [];
            var token = Account.getToken();
            var configBuilder = new CategoryConfigBuilder();
            var params = configBuilder
                .setConfig(Vue.bzbsConfig.mainConfig.MenuConfig)
                .setLocale(Locale.getLocale().code);

            BzbsCampaign.apiGetCategory(token, params.categoryConfig)
                .then(result => {
                    if (result && result.length > 0) {
                        for (var i = 0; i < result.length; i++) {
                            this.cateList.push(result[i]);
                        }
                    }
                    console.log(this.cateList);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        initialSeeMore: function () {
            this.removeScrollEvent();
            window.onscroll = () => {
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            }
        },
        removeScrollEvent: function() {
            window.onscroll = null;
        },
        //event
        getCategoryName: function (categoryID) {
            for (var i = 0; i < this.cateList.length; i++) {
                if (categoryID == this.cateList[i].id) {
                    return this.cateList[i].name;
                }
            }

            return "";
        },
        clickPurchase: function (index) {
            //check internet stuff.
            if (this.isSerialLoading) return;
            this.isSerialLoading = true;

            var purchase = this.purchases[index];

            var label = purchase.id+"|"+purchase.name;
            var gtm = {
                        "event_label": purchase.name,
                        "privilege_category_name": this.getCategoryName(purchase.categoryID),
                        "privilege_id": purchase.id,
                        "timestamp": moment().format("YYYYMMDD HH:mm:ss")
                    };
            Vue.ga.event(this, "privilege_campaign", "click_campaign", label);
            Vue.ga.event(this, "privilege", "use_privilege", label, null, gtm);

            this.clickedIndex = index;
            if (!this.isShowSerialModal(purchase))
            {
                this.isSerialLoading = false;
                return;
            }

            var token = Account.getToken();
            if (purchase.type === this.campaignType.Interface) {
                var locale = Locale.getLocaleCode();
                var header = 'false';
                var theme = Vue.bzbsConfig.appname;
                if (purchase.website && purchase.website.indexOf('/Landing/starbucks') != -1) {
                        var returnUrl = encodeURIComponent(window.location.href);
                        var isLanding = '%3Flanding%3DTrue';
                        if (returnUrl.indexOf(isLanding) < 0) {
                            returnUrl += isLanding;
                        }


                        window.location.href = purchase.website +
                            '&token=' + token +
                            '&locale=' + locale +
                            '&RedeemKey=' + purchase.redeemKey +
                            '&header=' + header +
                            '&theme=' + theme +
                            '&return_url=' + returnUrl; // ReturnUrl;
                    } else {
                        this.isSerialLoading = false;
                        return;
                    }

            }

            BzbsHistory.apiRedeemUse(token, purchase.redeemKey)
                .then(result => {
                    this.isSerialLoading = false;
                    this.purchases[this.clickedIndex].updateAfterRedeem(result);

                    var tmpPurchase = this.purchases[this.clickedIndex];
                    if (this.isShowSerialModal(tmpPurchase))
                        this.busSerialModal.$emit('showSerialModal', purchase);
                    else
                        this.forceRender();
                })
                .catch(error => {
                    this.isSerialLoading = false;
                    console.log(error);
                });
        },
        //method
        getList: function () {
            var token = Account.getToken();
            BzbsHistory.apiGetPurchase(token, this.listConfig, this.filterConfig)
                .then(purchases => {
                    this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                    //check is there are more campaign.
                    if (purchases &&
                        purchases.length < this.listConfig.defaultTopAmount)
                        this.listConfig.isSeeMoreEnable = false;
                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip == this.listConfig.defaultTopAmount)
                        this.purchases = [];

                    for (var purchase of purchases) {
                        //TODO: Add GA Tracking.
                        this.purchases.push(purchase);
                    }

                    this.isLoaded = true;
                    this.isHaveItem = this.purchases.length > 0
                        ? true
                        : false;

                    this.hideLoading();
                    setTimeout(() => {
                        this.isLoadedMore = true;
                    }, 500);
                })
                .catch(error => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.hideLoading();
                    setTimeout(() => {
                        this.isLoadedMore = true;
                    }, 500);
                    console.log(error);
                });
        },
        loadMore: function () {

            if (!this.listConfig.isSeeMoreEnable) return;
            if (this.showLoading()) return;
            if (!this.isLoadedMore) return;

            this.isLoadedMore = false;
            setTimeout(() => {
                console.log('load more');
                this.getList();
            }, 500);
        },
        isShowSerialModal: function (purchase) {
            if (purchase.serial === 'XXXXXXX') return false;
            if (purchase.expireIn && purchase.expireIn <= 0) return false;

            if (purchase.type === this.campaignType.Interface) {
                if (purchase.pointType === "get")
                    return false;

                return true;
            }

            if (purchase.type === this.campaignType.Free ||
                purchase.type === this.campaignType.Deal ||
                purchase.type === this.campaignType.Buy) {
                if (purchase.delivered)  return false;
            }

            if (purchase.type === this.campaignType.Draw) return false;

            return true;
        },
        //utilities
        showLoading: function () {
            if (this.isLoading) return true;

            this.toggleLoading(true);
            this.busModal.$emit('showLoadingModal', {});

            return false;
        },
        hideLoading: function () {
            this.toggleLoading(false);
            this.busModal.$emit('hideLoadingModal', {});
        },
        forceRender: function () {
            this.isForceRender = false;

            this.$nextTick().then( () => {
                this.isForceRender = true;
            });
        },
        refreshList: function () {
            var tmp = this.purchases;
            this.purchases = [];
            this.purchases = tmp;
        },
        //bus event
        switchLang: function () {
            this.purchases = [];
            this.getList();
        },
        toggleLoading: function (isLoading) {
            this.$emit('toggleLoading', isLoading);
        },
        serialExpired: function () {
            this.purchases[this.clickedIndex].setPurchaseExpired();
            this.refreshList();
        }
    }
};
</script>
<style lang="scss" scoped>
//@import '@/style/base/base.scss';
@import "@/style/base/common.scss";
.list {
    width: 100%;

    .list-wrapper {
        @extend %display-flex;
        width: 100%;
    }
}

.empty-text {
    padding: 200px 0px 15px 0px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    color: $gray-color;
}
</style>
